module.exports = __webpack_public_path__ + "img/abstract-shapes-19-square.4c26d3b1.svg";